import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import UserRoles from "constants/UserRoles";
import classNames from "classnames";

const breadcrumbsStatic = [{
	name: "Financial's",
	url: '/financial',
	icon: 'credit-card',
}];

export default class Financial extends Framework.Components.View {

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];
	constructor(props) {
		super(props,"details");
	}



	render() {
		let {match, history, baseUrl} = this.props;
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				// TODO, check where state is set in View, then can update this on state state change
				name:`${match.params.id}`,
				url: `/financial/${match.params.id}`,
				icon: 'credit-card',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>

					<Tab  label="details" value="details"/>
					<Tab  label="Change Log" value="logs"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
					<Objects.Financial
						id={match.params.id}
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
						roles={this.props.roles}
						financial={true}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'logs'})}>
					<Collections.LogsFinancials
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={this.props.roles.includes(UserRoles.Admin)}
					/>
				</div>
			</div>
		);
	}
}



